import { Injectable } from '@angular/core';
import { FormControl, Validators, ValidatorFn } from '@angular/forms';
import { TextDataResponseDTO } from '../authentication/connection/interfaces/apiInterfaces';

@Injectable()
export class FormControlService {
  constructor() {}
  addValidations(
    data: TextDataResponseDTO,
    value?: string | boolean | number | Date
  ): FormControl {
    let formControl = new FormControl(value, { updateOn: 'blur' });
    let validatorFn: ValidatorFn[] = [];
    if (!data) {
      return formControl;
    }
    if (data.max !== null && data.max !== undefined) {
      validatorFn.push(Validators.max(data.max));
    }
    if (data.min !== null && data.min !== undefined) {
      validatorFn.push(Validators.min(data.min));
    }
    if (
      data.validationRegex !== null &&
      data.validationRegex !== undefined &&
      data.validationRegex !== ''
    ) {
      validatorFn.push(Validators.pattern(data.validationRegex));
    }
    if (
      data.requiredField !== null &&
      data.requiredField !== undefined &&
      data.requiredField !== false
    ) {
      validatorFn.push(Validators.required);
    }
    formControl.setValidators(validatorFn);
    return formControl;
  }
}
